import authImg from "../assets/images/auth_img.jpg";
import csvFileIcon from "../assets/images/csv_file_icon.png";
import mainLogoWhite from "../assets/images/logo-white.png";
import mainlogo from "../assets/images/logo.png";
import ajclLogo from "../assets/images/main_logo.png";

export const images = {
  authImg,
  mainlogo,
  csvFileIcon,
  mainLogoWhite,
  ajclLogo
};
